import React, {useEffect, useState} from "react";
import {useWatch} from "react-hook-form";
import {useSelector} from "react-redux";
import {css} from "@emotion/react";

import {mb, p} from "@pg-design/helpers-css-strings";
import {SelectFieldControlled} from "@pg-design/react-hook-forms-utils";
import {getThemeBreakpoint, getThemeVariable} from "@pg-design/styles-strings";

import {IRPStore} from "../../../app/rp_reducer";
import {IRegionListRegion} from "../../../search/actions/fetch_search_regions_action";
import {ISearchInputRegion} from "../../../search/components/ISearchInputValue";
import {SearchInteractiveRegionsMap} from "../../../search/components/search_interactive_regions_map/SearchInteractiveRegionsMap";
import {useAppDispatch} from "../../../store/hooks";
import {setForYouRegion} from "../../state/for_you_modal_slice";
import {SubmitHandlerType} from "../../types/SubmitHandlerType";
import {ForYouModalButton} from "../modal_parts/ForYouModalButton";

interface IProps {
    submitHandler: SubmitHandlerType;
    onNextStep: () => void;
    availableRegions?: IRegionListRegion[];
}

export const ForYouRegionForm = (props: IProps) => {
    const searchFormValues = useSelector((state: IRPStore) => state.search.formValues);
    const dispatch = useAppDispatch();
    const region = useWatch({name: "region"});
    const selectedRegion = props.availableRegions?.find((city) => city.id === region?.value);
    const [mapRegions, setMapRegions] = useState<ISearchInputRegion[]>([]);
    const [values, setValues] = useState(searchFormValues);

    const onSubmit = () => {
        dispatch(setForYouRegion(mapRegions));
        props.onNextStep();
    };

    useEffect(() => {
        const changeRegion = mapRegions[0]?.id !== region?.value || mapRegions[0]?.parent?.id !== region?.value;
        if (changeRegion && mapRegions.length > 0) {
            setValues({...searchFormValues, search: {label: selectedRegion?.name, tabType: values.search.tabType, regions: [selectedRegion]}});
        }
    }, [region]);

    const options = props.availableRegions?.map((region) => ({label: region.name, value: region.id}));

    return (
        <form onSubmit={props.submitHandler(onSubmit)} css={regionForm}>
            <SelectFieldControlled name="region" options={options} placeholder="Wybierz miasto" isSearchable css={selectStyle} />

            <div css={mapHolder}>
                <SearchInteractiveRegionsMap
                    formValues={values}
                    defaultDistanceValue={0}
                    updateSelectedRegions={(option) => {
                        if ("regions" in option) {
                            setMapRegions(option.regions);
                        }
                        if ("distance" in option) {
                            setValues({...values, distance: option.distance});
                        }
                    }}
                    search={values.search}
                    isInModal
                    updateRegionsImmediately
                />
            </div>

            <ForYouModalButton isDisabled={!mapRegions.length} showStep />
        </form>
    );
};

const regionForm = css`
    width: 100%;
    position: relative;
    ${p(3, 1.5, 0, 1.5)};

    @media (min-width: ${getThemeBreakpoint().md}) {
        background-color: ${getThemeVariable("colors.gray.100")};
        ${p(3, 3, 1, 3)};
    }
`;

const selectStyle = css`
    ${mb(2)};
`;

const mapHolder = css`
    @media (min-width: ${getThemeBreakpoint().md}) {
        ${mb(2)};
    }
`;
import React, {useEffect, useState} from "react";
import {useWatch} from "react-hook-form";
import {useSelector} from "react-redux";
import {css} from "@emotion/react";

import {mb, p} from "@pg-design/helpers-css-strings";
import {SelectFieldControlled} from "@pg-design/react-hook-forms-utils";
import {getThemeBreakpoint, getThemeVariable} from "@pg-design/styles-strings";

import {IRPStore} from "../../../app/rp_reducer";
import {IRegionListRegion} from "../../../search/actions/fetch_search_regions_action";
import {ISearchInputRegion} from "../../../search/components/ISearchInputValue";
import {SearchInteractiveRegionsMap} from "../../../search/components/search_interactive_regions_map/SearchInteractiveRegionsMap";
import {useAppDispatch} from "../../../store/hooks";
import {setForYouRegion} from "../../state/for_you_modal_slice";
import {SubmitHandlerType} from "../../types/SubmitHandlerType";
import {ForYouModalButton} from "../modal_parts/ForYouModalButton";

interface IProps {
    submitHandler: SubmitHandlerType;
    onNextStep: () => void;
    availableRegions?: IRegionListRegion[];
}

export const ForYouRegionForm = (props: IProps) => {
    const searchFormValues = useSelector((state: IRPStore) => state.search.formValues);
    const dispatch = useAppDispatch();
    const region = useWatch({name: "region"});
    const selectedRegion = props.availableRegions?.find((city) => city.id === region?.value);
    const [mapRegions, setMapRegions] = useState<ISearchInputRegion[]>([]);
    const [values, setValues] = useState(searchFormValues);

    const onSubmit = () => {
        dispatch(setForYouRegion(mapRegions));
        props.onNextStep();
    };

    useEffect(() => {
        const changeRegion = mapRegions[0]?.id !== region?.value || mapRegions[0]?.parent?.id !== region?.value;
        if (changeRegion && mapRegions.length > 0) {
            setValues({...searchFormValues, search: {label: selectedRegion?.name, tabType: values.search.tabType, regions: [selectedRegion]}});
        }
    }, [region]);

    const options = props.availableRegions?.map((region) => ({label: region.name, value: region.id}));

    return (
        <form onSubmit={props.submitHandler(onSubmit)} css={regionForm}>
            <SelectFieldControlled name="region" options={options} placeholder="Wybierz miasto" isSearchable css={selectStyle} />

            <div css={mapHolder}>
                <SearchInteractiveRegionsMap
                    formValues={values}
                    defaultDistanceValue={0}
                    updateSelectedRegions={(option) => {
                        if ("regions" in option) {
                            setMapRegions(option.regions);
                        }
                        if ("distance" in option) {
                            setValues({...values, distance: option.distance});
                        }
                    }}
                    search={values.search}
                    isInModal
                    updateRegionsImmediately
                />
            </div>

            <ForYouModalButton isDisabled={!mapRegions.length} showStep />
        </form>
    );
};

const regionForm = css`
    width: 100%;
    position: relative;
    ${p(3, 1.5, 0, 1.5)};

    @media (min-width: ${getThemeBreakpoint().md}) {
        background-color: ${getThemeVariable("colors.gray.100")};
        ${p(3, 3, 1, 3)};
    }
`;

const selectStyle = css`
    ${mb(2)};
`;

const mapHolder = css`
    @media (min-width: ${getThemeBreakpoint().md}) {
        ${mb(2)};
    }
`;
